import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import classes from "./Design.module.css";
import { useDispatch, useSelector } from "react-redux";
import { designSliceActions } from "../../../../store/design-slice";

const Design = () => {
  const [open, setOpen] = useState(false);
  const designData = useSelector((state) => state.design);
  const dispatch = useDispatch();
  const layoutDummy =
    "data:image/png;base64,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";

  const fontFamilyHandler = (event) => {
    dispatch(
      designSliceActions.setFontFamily({
        fontFamily: event.target.id,
      })
    );
  };

  const fontSizeHandler = (event) => {
    dispatch(
      designSliceActions.setFontSize({
        fontSize: event.target.value,
      })
    );
  };

  const tempColorHandler = (event) => {
    dispatch(
      designSliceActions.setTempColor({
        tempColor: event.target.value,
      })
    );
  };

  const textColorHandler = (event) => {
    dispatch(
      designSliceActions.setTextColor({
        textColor: event.target.value,
      })
    );
  };

  const layoutHandler = (event) => {
    dispatch(
      designSliceActions.setLayout({
        layout: +event.currentTarget.id,
      })
    );
  };

  return (
    <div className={classes.main}>
      <Typography color="#2C4166" paragraph fontSize={18} gutterBottom>
        Layout
      </Typography>
      <div className={classes["capsule-textfield"]}>
        <label htmlFor="name">Font Family</label>
        <FormControl sx={{ m: 1, minWidth: 120, paddingTop: "5px" }}>
          <InputLabel id="demo-controlled-open-select-label">
            Font Family
          </InputLabel>
          <Select
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            value={designData.fontFamily}
            label="font-family"
          >
            <MenuItem
              onClick={fontFamilyHandler}
              value="Segoe UI"
              id="Segoe UI"
            >
              Segoe UI
            </MenuItem>
            <MenuItem onClick={fontFamilyHandler} value="Arial" id="Arial">
              Arial
            </MenuItem>
            <MenuItem
              onClick={fontFamilyHandler}
              value="Arial Black"
              id="Arial Black"
            >
              Arial Black
            </MenuItem>
            <MenuItem
              onClick={fontFamilyHandler}
              value="Comic Sans MS"
              id="Comic Sans MS"
            >
              Comic Sans MS
            </MenuItem>
            <MenuItem
              onClick={fontFamilyHandler}
              value="Courier New"
              id="Courier New"
            >
              Courier New
            </MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className={classes["capsule-textfield"]}>
        <label htmlFor="fontSize">Font Size</label>
        <div>
          <input
            type="range"
            min="6"
            max="24"
            defaultValue="16"
            value={designData.fontSize}
            step="0.5"
            className="slider"
            id="fontSize"
            onChange={fontSizeHandler}
          />
        </div>
      </div>
      <div className={classes["capsule-textfield"]}>
        <label htmlFor="tempColor">Template Color</label>
        <div>
          <input
            onChange={tempColorHandler}
            value={designData.tempColor}
            type="color"
            name="tempColor"
            id={classes.tempColor}
          />
        </div>
      </div>
      <div className={classes["capsule-textfield"]}>
        <label htmlFor="textColor">Text Color</label>
        <div>
          <input
            onChange={textColorHandler}
            value={designData.textColor}
            type="color"
            name="textColor"
            id={classes.textColor}
          />
        </div>
      </div>

      <div className={classes.layouts}>
        <div>
          <div id="1" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#1" />
          </div>
          <span className={classes["layout-text"]}>Layout# 1</span>
        </div>
        <div>
          <div id="2" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#2" />
          </div>
          <span className={classes["layout-text"]}>Layout# 2</span>
        </div>
        <div>
          <div id="3" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#3" />
          </div>
          <span className={classes["layout-text"]}>Layout# 3</span>
        </div>
        <div>
          <div id="4" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#4" />
          </div>
          <span className={classes["layout-text"]}>Layout# 4</span>
        </div>
        <div>
          <div id="5" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#5" />
          </div>
          <span className={classes["layout-text"]}>Layout# 5</span>
        </div>
        <div>
          <div id="6" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#6" />
          </div>
          <span className={classes["layout-text"]}>Layout# 6</span>
        </div>
        <div>
          <div id="7" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#7" />
          </div>
          <span className={classes["layout-text"]}>Layout# 7</span>
        </div>
        <div>
          <div id="8" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#8" />
          </div>
          <span className={classes["layout-text"]}>Layout# 8</span>
        </div>
        <div>
          <div id="9" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#9" />
          </div>
          <span className={classes["layout-text"]}>Layout# 9</span>
        </div>
        <div>
          <div id="10" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#10" />
          </div>
          <span className={classes["layout-text"]}>Layout# 10</span>
        </div>
        <div>
          <div id="11" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#11" />
          </div>
          <span className={classes["layout-text"]}>Layout# 11</span>
        </div>
        <div>
          <div id="12" onClick={layoutHandler}>
            <img className={classes.layout} src={layoutDummy} alt="layout#12" />
          </div>
          <span className={classes["layout-text"]}>Layout# 12</span>
        </div>
      </div>
    </div>
  );
};

export default Design;
